import React, { useEffect, useState } from 'react'
import { Alert, Button, Card, Empty, Spin, Table, Tabs, Tag } from 'antd'
import { getAicDashboardProjectTables, getAicDashboardProjectTableData } from '../../request'

const label = item => item.displayName && item.displayName !== item.name ? `${item.displayName}（${item.name}）` : item.name
const emptyPage = { columns: [], rows: [], total: 0 }

/** AIC 和 Vibe 共用；只请求当前表和当前页，切换时丢弃旧请求结果。 */
export default function ProjectData ({ projectId }) {
  const [tables, setTables] = useState([])
  const [tableKey, setTableKey] = useState('')
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20 })
  const [page, setPage] = useState(emptyPage)
  const [tablesLoading, setTablesLoading] = useState(true)
  const [rowsLoading, setRowsLoading] = useState(false)
  const [tablesError, setTablesError] = useState('')
  const [rowsError, setRowsError] = useState('')
  const [retryTables, setRetryTables] = useState(0)
  const [retryRows, setRetryRows] = useState(0)

  useEffect(() => {
    let current = true
    setTablesLoading(true)
    setTablesError('')
    setTables([])
    setTableKey('')
    setPage(emptyPage)
    getAicDashboardProjectTables(projectId).then(result => {
      if (!current) return
      const list = Array.isArray(result && result.tables) ? result.tables : []
      setTables(list)
      setPagination({ current: 1, pageSize: 20 })
      setTableKey(list.length ? String(list[0].key) : '')
    }).catch(error => {
      if (current) setTablesError(error && error.message ? error.message : '数据表加载失败，请重试')
    }).finally(() => { if (current) setTablesLoading(false) })
    return () => { current = false }
  }, [projectId, retryTables])

  useEffect(() => {
    if (!tableKey) return
    let current = true
    setRowsLoading(true)
    setRowsError('')
    setPage(emptyPage)
    getAicDashboardProjectTableData(projectId, { tableKey, pageNum: pagination.current, pageSize: pagination.pageSize })
      .then(result => {
        if (current) setPage(result || emptyPage)
      }).catch(error => {
        if (current) setRowsError(error && error.message ? error.message : '数据加载失败，请重试')
      }).finally(() => { if (current) setRowsLoading(false) })
    return () => { current = false }
  }, [projectId, tableKey, pagination.current, pagination.pageSize, retryRows])

  const changeTable = key => {
    setPage(emptyPage)
    setRowsError('')
    setPagination(value => ({ ...value, current: 1 }))
    setTableKey(key)
  }
  const columns = (page.columns || []).map(column => ({
    title: label(column), key: column.key, dataIndex: [column.key], width: 180, ellipsis: true,
    render: value => value === null || value === undefined || value === '' ? '-' : String(value)
  }))
  const rows = (page.rows || []).map((row, index) => ({ ...row, __rowKey: `${tableKey}-${pagination.current}-${index}` }))

  return <Card className="aic-panel aic-data-panel" title="数据" extra={<Tag color="blue">只读</Tag>}>
    {tablesLoading ? <div className="aic-data-loading"><Spin /></div> : tablesError ?
      <Alert type="error" showIcon message={tablesError} action={<Button size="small" onClick={() => setRetryTables(value => value + 1)}>重试</Button>} /> :
      tables.length === 0 ? <Empty description="暂无可展示的数据表" /> : <>
        <Tabs activeKey={tableKey} onChange={changeTable} aria-label="项目数据表"
          items={tables.map(table => ({ key: String(table.key), label: label(table) }))} />
        {rowsError ? <Alert type="error" showIcon message={rowsError} action={<Button size="small" onClick={() => setRetryRows(value => value + 1)}>重试</Button>} /> :
          <Table
            size="small" loading={rowsLoading} rowKey="__rowKey" columns={columns} dataSource={rows}
            scroll={{ x: Math.max(720, columns.length * 180) }}
            locale={{ emptyText: <Empty description="暂无数据" /> }}
            pagination={{
              current: page.pageNum || pagination.current, pageSize: pagination.pageSize, total: page.total || 0,
              showSizeChanger: true, pageSizeOptions: ['20', '50', '100'], showTotal: total => `共 ${total} 行`,
              onChange: (current, pageSize) => setPagination(value => ({ current: value.pageSize === pageSize ? current : 1, pageSize }))
            }}
          />}
        <div className="aic-data-note">长文本展示前 4000 个字符，二进制字段显示占位提示。</div>
      </>}
  </Card>
}
